import { useQuery } from "@tanstack/react-query";

import API from "../utils/Axios.utils";
import logger from "../utils/logger";

const OFFERS_ENDPOINT = "/api/offers";
// Reuse the loaded list when moving between the list and an offer.
const OFFERS_STALE_MS = 60 * 1000;

const fetchOffers = async () => {
  const { data } = await API.get(OFFERS_ENDPOINT);
  const offers = Array.isArray(data) ? data : [];
  logger.debug(`[Offers] Loaded ${offers.length} offer(s).`);
  return offers;
};

/**
 * The signed-in user's offers (whole tenant for a manager). Shared by the
 * manager's Offers list and offer detail pages, so opening an offer does not
 * load the list again.
 */
const useOffers = () =>
  useQuery({
    queryKey: ["offers"],
    queryFn: fetchOffers,
    staleTime: OFFERS_STALE_MS,
    retry: 1,
  });

export default useOffers;
